import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const data = [
  {
    category: "Anesthesia",
    ipdexpense: "₹ 1,12,00",
    ipdSubCategory: "Anesthesia Charge",
    ipdDataExpense: "₹ 1,12,00",
    opdExpense: "₹ 0",
    opdSubCategory: "Anesthesia Charge",
    opdDataExpense: "₹ 0",
  },
  {
    category: "Anesthesia",
    ipdexpense: "₹ 1,12,00",
    ipdSubCategory: "Anesthesia Charge",
    ipdDataExpense: "₹ 1,12,00",
    opdExpense: "₹ 0",
    opdSubCategory: "Anesthesia Charge",
    opdDataExpense: "₹ 0",
  },
  {
    category: "Anesthesia",
    ipdexpense: "₹ 1,12,00",
    ipdSubCategory: "Anesthesia Charge",
    ipdDataExpense: "₹ 1,12,00",
    opdExpense: "₹ 0",
    opdSubCategory: "Anesthesia Charge",
    opdDataExpense: "₹ 0",
  },
];

export default function ReportsFinanceDashboardTable() {
  return (
    <TableContainer component={Paper}>
      <Table>
        {/* Table Head */}
        <TableHead>
          {/* First Row - Merged Headers */}
          <TableRow>
            <TableCell
              rowSpan={3}
              sx={{
                fontWeight: "bold",
                background: "#d3d3d3",
                borderRight: "2px solid white",
                borderTopLeftRadius: "10px",
              }}
            >
              Category
            </TableCell>

            <TableCell
              colSpan={3}
              align="center"
              sx={{
                fontWeight: "bold",
                background: "#c4c4c4",
                borderRight: "2px solid white",
              }}
            >
              IPD
            </TableCell>
            <TableCell
              colSpan={3}
              align="center"
              sx={{
                fontWeight: "bold",
                background: "#c4c4c4",
                borderTopRightRadius: "10px",
              }}
            >
              OPD
            </TableCell>
          </TableRow>

          {/* Second Row - Sub Headers */}
          <TableRow>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
              }}
              rowSpan={2}
            >
              Expense
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
                textAlign: "center",
                borderBottom: "1px solid white",
              }}
              colSpan={2}
            >
              Data
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              Expense
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
                textAlign: "center",
                borderBottom: "1px solid white",
              }}
              colSpan={2}
            >
              Data
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
              }}
            >
              Sub Category
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
              }}
            >
              Expense
            </TableCell>

            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
                borderRight: "2px solid white",
              }}
            >
              Sub Category
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                background: "#e0e0e0",
              }}
            >
              Expense
            </TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.category}</TableCell>
              <TableCell>{row.ipdexpense}</TableCell>
              <TableCell>{row.ipdSubCategory}</TableCell>
              <TableCell>{row.ipdDataExpense}</TableCell>
              <TableCell>{row.opdExpense}</TableCell>
              <TableCell>{row.opdSubCategory}</TableCell>
              <TableCell>{row.opdDataExpense}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
